import { Client as Styletron } from 'styletron-engine-atomic';

const debug = import.meta.env.MODE === 'production';

const engine = new Styletron({ prefix: '_' });

export { debug, engine };
